import { Divider, Flex, Space, Switch, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import InfoTooltip from "../../../Components/InfoTooltip/InfoTooltip"
import Icon from "../../../Icon"
import { useDemoDataToggle } from "../../User/hooks/useDemoDataToggle"

import "../styles.less"
import "./DemoModeBanner.less"

const { Text } = Typography

const DemoModeBanner = ({ isMobile }) => {
  const { userInfo } = useSelector((state) => state.auth)
  const { isShowDemoData, toggleDemoData, loading } = useDemoDataToggle()
  const { t } = useTranslation()

  const isLightMode = userInfo?.is_light_mode

  return (
    <>
      <Flex vertical gap={12} className="additional-message-block demo-mode-sidebar-banner">
        <Flex data-tour="demo-mode-banner" vertical gap={12}>
          <Icon className="lock-icon" type="lock" style={{ fontSize: 20 }} />
          <Space size={4} direction="vertical" style={{ maxWidth: isMobile && 240 }}>
            <Space size={4}>
              <Text>Chargeback DEMO</Text>
              <InfoTooltip title="You are currently in demo mode. All data is simulated, some features are limited. The purpose of this mode is to demonstrate how the platform works." />
            </Space>

            <Text
              type="secondary"
              style={{ maxWidth: isMobile && "240px", fontWeight: isMobile && 400 }}
            >
              {t(
                "You are currently on Chargeback DEMO mode. Top up your balance to get activated."
              )}
            </Text>
          </Space>
        </Flex>
        {/* {isMobile && <NavLink to={"/settings/balance?open_add_funds=true"}>
          <Button className="balance-btn" size="small" type="primary">
            {t("Top up balance")}
          </Button>
        </NavLink> */}
        {!isLightMode && (
          <Flex gap={8} align="center">
            <Switch checked={isShowDemoData} onChange={toggleDemoData} loading={loading} />
            <Text strong>DEMO mode</Text>
          </Flex>
        )}
      </Flex>
      {!isMobile && <Divider type={"horizontal"} style={{ margin: "10px auto 16px" }} />}
    </>
  )
}

export default DemoModeBanner
